'use strict';

var _ = require('lodash');

/* this is the place to add function used by the custom render of a string E.g $render function.*/

module.exports = {
    identity: _.identity
};
//# sourceMappingURL=functions.js.map